module.exports = __webpack_public_path__ + "img/5-3.caae1315.svg";